import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["cell", "indicator", "note", "status"]

  connect() {
    this.initialValues = new Map(this.controls.map((control) => [control.name, control.value]))
    document.addEventListener("input", this.update)
    document.addEventListener("change", this.update)
    document.addEventListener("time-field:formatted", this.update)
    this.cellTargets.forEach((cell) => this.updateNoteVisibility(cell.dataset.weekCellId))
  }

  disconnect() {
    document.removeEventListener("input", this.update)
    document.removeEventListener("change", this.update)
    document.removeEventListener("time-field:formatted", this.update)
  }

  update = (event) => {
    const control = event.target
    if (control.form !== this.element || !control.dataset.weekCellId) return

    this.updateCell(control.dataset.weekCellId)
    this.updateNoteVisibility(control.dataset.weekCellId)
    this.updateStatus()
  }

  updateCell(cellId) {
    const dirty = this.controlsFor(cellId).some(
      (control) => control.value !== this.initialValues.get(control.name)
    )
    const cell = this.cellTargets.find((candidate) => candidate.dataset.weekCellId === cellId)
    const indicator = this.indicatorTargets.find((candidate) => candidate.dataset.weekCellId === cellId)

    if (!cell) return

    cell.dataset.unsaved = dirty ? "true" : "false"
    if (indicator) indicator.classList.toggle("hidden", !dirty)
  }

  updateStatus() {
    if (!this.hasStatusTarget) return

    this.statusTarget.hidden = !this.hasUnsavedChanges
  }

  updateNoteVisibility(cellId) {
    const duration = this.controlsFor(cellId).find((control) => control.dataset.weekDurationInput)
    const note = this.noteTargets.find((candidate) => candidate.dataset.weekCellId === cellId)
    if (!duration || !note) return

    const hidden = duration.value.trim() === ""
    note.classList.toggle("hidden", hidden)
    if (hidden) note.removeAttribute("open")
  }

  controlsFor(cellId) {
    return this.controls.filter((control) => control.dataset.weekCellId === cellId)
  }

  get controls() {
    return Array.from(this.element.elements).filter((control) => control.dataset.weekCellId)
  }

  get hasUnsavedChanges() {
    return this.cellTargets.some((cell) => cell.dataset.unsaved === "true")
  }
}
